'use client'
import React, { PropsWithChildren } from 'react'

const Body: React.FC<PropsWithChildren> = props => {
  return <tbody {...props} />
}

export default Body
